<template>
    <div class="group-setting-components">
        <!-- 筛选 -->
        <form @submit.prevent="fetchData" class="flex justify-between">
            <div class="flex">
                <el-select
                    v-on:change="fetchData"
                    class="pr-2"
                    v-model="form.active"
                    :placeholder="$t('Common.store_placeholder')">
                    <el-option
                        v-for="(item, index) in actives"
                        :key="`${index}-${item.code}`"
                        :label="item.label"
                        :value="item.active">
                    </el-option>
                </el-select>
            </div>
            <el-tooltip class="item" effect="dark" :content="$t('tooltip.add')" placement="bottom">
                <div
                    @click="handleAddLessons"
                    class="iconfont icon-fitness-tianjiawenjian group-setting-icon flex justify-end">
                </div>
            </el-tooltip>
        </form>
        <el-table
            :data="tableData"
            style="width: 100%;margin: 15px 0;"
            border>
            <el-table-column fixed prop="name" :label="$t('Course.name')" />
            <el-table-column prop="duration" :label="$t('Week.time')" />
            <el-table-column prop="coachNicknames" :label="$t('Common.coach')" />
            <el-table-column :label="$t('Lesson.appoint_pay')">
                <template slot-scope="{row}">
                    {{ row.charge ? $t('Common.yes') : $t('Common.no') }}
                </template>
            </el-table-column>
            <el-table-column :label="$t('Reception.Fourth.status')">
                <template slot-scope="{row, $index}">
                    <div class="flex group-setting-icons">
                        <el-tooltip effect="dark" :content="$t('tooltip.check')" placement="bottom">
                            <div
                                class="iconfont icon-fitness-yanjing2"
                                @click="handleAddLessons('show', row.id)"></div>
                        </el-tooltip>
                        <el-tooltip effect="dark" :content="$t('tooltip.edit')" placement="bottom">
                            <div
                                class="iconfont
                                icon-fitness-icon-test-copy-copy-copy-copy-copy-copy-copy-copy-copy"
                                @click="handleAddLessons('edit', row.id)">
                            </div>
                        </el-tooltip>
                        <el-tooltip effect="dark" :content="$t('Lesson.pay_setting')" placement="bottom">
                            <div
                                class="iconfont icon-fitness-qian"
                                @click="handlePay(row)"></div>
                        </el-tooltip>
                        <el-tooltip effect="dark" :content="$t('tooltip.delete')"
                                    placement="bottom" v-if="row.active === true">
                            <div
                                class="iconfont icon-fitness-shanchu"
                                @click="handleDeleteLessons(row.id)"></div>
                        </el-tooltip>
                        <el-tooltip effect="dark" :content="$t('tooltip.refresh')"
                                    placement="bottom" v-if="row.active === false">
                            <div
                                    class="iconfont icon-fitness-huifu1"
                                    @click="handlePutLessons(row.id)"></div>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <!--<el-pagination-->
            <!--v-if="tableData && tableData.length"-->
            <!--class="text-right"-->
            <!--@current-change="fetchData"-->
            <!--:current-page.sync="form.page"-->
            <!--:page-size="pagination.size"-->
            <!--layout="total, prev, pager, next, jumper"-->
            <!--:total="pagination.total">-->
        <!--</el-pagination>-->

        <!-- 添加/编辑团课课程 -->
        <add-team-lesson ref="addLesson" @fetchData="fetchData"/>
        <!-- 付费设置 -->
        <group-setting-pay ref="settingPay" @fetchData="fetchData"/>
    </div>
</template>

<script>
import AddTeamLesson from '@/components/Dialog/GroupLessons/AddTeamLesson';
import GroupSettingPay from '@/components/Dialog/GroupLessons/GroupSettingPay';

export default {
    name: 'group-setting',
    components: {
        AddTeamLesson,
        GroupSettingPay,
    },
    props: ['activeName'],
    data() {
        return {
            tableData: [],
            pagination: {
                size: 10,
                total: 0,
            },
            form: {
                page: 1,
                active: true,
            },
            actives: [
                {
                    code: 1,
                    active: true,
                    label: this.$t('Reception.Fifth.normal'),
                },
                {
                    code: 0,
                    active: false,
                    label: this.$t('Lesson.deleted'),
                },
            ],
        };
    },
    watch: {
        'activeName'(val) {
            if (val === 'second') {
                this.fetchData();
            }
        },
    },
    created() {
        if (this.activeName === 'second') {
            this.fetchData();
        }
    },
    methods: {
        fetchData() {
            API.get('lesson/team/list', {
                params: this.form,
            }).then(res => {
                this.tableData = res;
            });
        },
        // 添加团课课程
        handleAddLessons(type, id) {
            // 传入参数获取数据
            if (this.$$filterPermission('课程-课程设置-团课/私教课程添加 修改 删除')) {
                if (type === 'edit' || type === 'show') this.$refs.addLesson.open(type, id);
                // else if (type === 'show') this.$refs.addLesson.open(type, id);
                else this.$refs.addLesson.open();
            } else {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
            }
        },
        handlePay(row) {
            if (row.charge === true) {
                this.$refs.settingPay.open(row.id);
            } else {
                $ele.$alert(this.$t('Alert.course_tip'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                });
            }
        },
        handleDeleteLessons(id) {
            $ele.$confirm(this.$t('Alert.course_tip2'), this.$t('Alert.course_tip3'), {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                if (this.$$filterPermission('课程-课程设置-团课/私教课程添加 修改 删除')) {
                    API.delete(`lesson/team/${id}/active`).then(() => {
                        $ele.$message.success(this.$t('Message.success'));
                        this.fetchData();
                    });
                } else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }).catch(() => {
                // $ele.$message('取消操作');
            });
        },
        handlePutLessons(id) {
            $ele.$confirm(this.$t('Alert.course_refresh'), this.$t('Message.tip_title'), {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                API.put(`lesson/team/${id}/active`).then(() => {
                    $ele.$message.success(this.$t('Message.success'));
                    this.fetchData();
                });
            }).catch(() => {
                // $ele.$message('取消操作');
            });
        },
    },
};
</script>

<style lang="scss">
.group-setting-icon {
    font-size: 24px;
    color: #697a8e;
    margin: 20px 12px 0 0;
}
.group-setting-icons {
    .iconfont {
        font-size: 15px;
        margin-right: 10px;
    }
    color: #697a8e;
}
</style>
